import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, Typography, IconButton } from '@mui/material';
import { Icon } from '@iconify/react';
interface CheckerApprovalModalProps {
  open: boolean;
  onClose: () => void;
  record: any;
  action: 'complete' | 'reject';
  onSubmit: (reason: string) => void;
}
const CheckerApprovalModal: React.FC<CheckerApprovalModalProps> = ({
  open,
  onClose,
  record,
  action,
  onSubmit
}) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState(false);
  const handleSubmit = () => {
    if (!reason.trim()) {
      setError(true);
      return;
    }
    onSubmit(reason);
    setReason('');
    setError(false);
  };
  const handleClose = () => {
    setReason('');
    setError(false);
    onClose();
  };
  return <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth PaperProps={{
    sx: {
      borderRadius: 2
    }
  }} data-id="element-496">
      <DialogTitle sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      pb: 2
    }} data-id="element-497">
        <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }} data-id="element-498">
          <Icon icon={action === 'complete' ? 'lucide:check-circle' : 'lucide:x-circle'} width={24} height={24} color={action === 'complete' ? '#10B981' : '#EF4444'} data-id="element-499" />
          <Typography variant="h6" fontWeight={600} data-id="element-500">
            {action === 'complete' ? 'Complete Record' : 'Reject Record'}
          </Typography>
        </Box>
        <IconButton onClick={handleClose} size="small" data-id="element-501">
          <Icon icon="lucide:x" width={20} height={20} data-id="element-502" />
        </IconButton>
      </DialogTitle>
      <DialogContent data-id="element-503">
        <Box sx={{
        mb: 3,
        p: 2,
        backgroundColor: '#F8FAFC',
        borderRadius: 1
      }} data-id="element-504">
          <Typography variant="body2" color="text.secondary" gutterBottom data-id="element-505">
            Record Details
          </Typography>
          <Typography variant="body1" fontWeight={600} data-id="element-506">
            {record?.fullName}
          </Typography>
          <Typography variant="body2" color="text.secondary" data-id="element-507">
            {record?.email} • {record?.mobile}
          </Typography>
        </Box>
        <TextField fullWidth multiline rows={4} label="Reason (Required)" placeholder={`Enter reason for ${action === 'complete' ? 'completing' : 'rejecting'} this record...`} value={reason} onChange={e => {
        setReason(e.target.value);
        setError(false);
      }} error={error} helperText={error ? 'Reason is required' : ''} sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: 2
        }
      }} data-id="element-508" />
      </DialogContent>
      <DialogActions sx={{
      p: 3,
      pt: 2
    }} data-id="element-509">
        <Button variant="outlined" onClick={handleClose} data-id="element-510">
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSubmit} sx={{
        backgroundColor: action === 'complete' ? '#10B981' : '#EF4444',
        '&:hover': {
          backgroundColor: action === 'complete' ? '#059669' : '#DC2626'
        }
      }} data-id="element-511">
          {action === 'complete' ? 'Complete' : 'Reject'}
        </Button>
      </DialogActions>
    </Dialog>;
};
export default CheckerApprovalModal;